module.exports = "<bulk-invoice-item-types-upload-page></bulk-invoice-item-types-upload-page>\n";


//////////////////
// WEBPACK FOOTER
// ./src/views/appSettings/bulkInvoiceItemTypesUploadView.html
// module id = 2206
// module chunks = 0